import { render } from "./OfferDetails.vue?vue&type=template&id=2dbc68ab"
import script from "./OfferDetails.vue?vue&type=script&lang=js"
export * from "./OfferDetails.vue?vue&type=script&lang=js"

import "./OfferDetails.vue?vue&type=style&index=0&id=2dbc68ab&lang=css"
import "./OfferDetails.vue?vue&type=style&index=1&id=2dbc68ab&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__